// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectHelpPage3_container__13wiv","text":"ProjectHelpPage3_text__n0ogs","example":"ProjectHelpPage3_example__3l6Vz","button":"ProjectHelpPage3_button__380ZW"};